import React from "react";
import { AppstoreOutlined, BarsOutlined } from "@ant-design/icons";
import { Segmented } from "antd";
import { cn } from "../../utils/cn";

const ListGridButtons = ({ viewType, setViewType, viewFor, className }) => {
  return (
    <div className={cn("h-[40px] flex items-center", className)}>
      <Segmented
        value={viewType}
        onChange={(value) => {
          localStorage.setItem(`${viewFor}`, value);
          setViewType(value);
        }}
        options={[
          {
            value: "LIST",
            label: <BarsOutlined className="text-lg" />,
            className: "!h-[35px]",
          },
          {
            value: "GRID",
            label: <AppstoreOutlined className="text-lg" />,
            className: "!h-[35px]",
          },
        ]}
        rootClassName="
          [&_.ant-segmented-item]:flex
          [&_.ant-segmented-item]:items-center
          [&_.ant-segmented-item]:justify-center

          [&_.ant-segmented-item-label]:flex
          [&_.ant-segmented-item-label]:items-center
          [&_.ant-segmented-item-label]:justify-center
        "
        className="h-full"
      />
    </div>
  );
};

export default ListGridButtons;
